import React, { useState } from 'react';
import { useTranslation } from '../utils/i18n';
import './SearchBox.css';

interface SearchBoxProps {
  onSubmit?: (searchTerm: string) => void;
  onSearch?: (searchTerm: string) => void;
  placeholder?: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({ 
  onSubmit, 
  onSearch, 
  placeholder 
}) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');

  const defaultPlaceholder = placeholder || t('shared.search');

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(searchTerm);
    }
    console.log("Search submitted:", searchTerm);
  };

  const handleKeydown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSubmit();
      e.preventDefault();
    }
  };

  const handleBlur = () => {
    handleSubmit();
  };

  return (
    <div className="input-group">
      <div className="icon-search">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 18"
          height="18"
          width="18"
        >
          <path
            d="M17.7808 16.7203L13.3041 12.2436C14.524 10.7515 15.1239 8.84764 14.9795 6.92574C14.8351 5.00384 13.9575 3.21097 12.5283 1.91796C11.099 0.624952 9.22751 -0.0692619 7.3008 -0.0210881C5.37409 0.0270858 3.5396 0.813961 2.17678 2.17678C0.813961 3.5396 0.0270858 5.37409 -0.0210881 7.3008C-0.0692619 9.22751 0.624952 11.099 1.91796 12.5283C3.21097 13.9575 5.00384 14.8351 6.92574 14.9795C8.84764 15.1239 10.7515 14.524 12.2436 13.3041L16.7203 17.7808C16.8618 17.9174 17.0512 17.993 17.2479 17.9913C17.4445 17.9896 17.6326 17.9107 17.7717 17.7717C17.9107 17.6326 17.9896 17.4445 17.9913 17.2479C17.993 17.0512 17.9174 16.8618 17.7808 16.7203ZM7.50057 13.5006C6.31388 13.5006 5.15384 13.1487 4.16715 12.4894C3.18045 11.8301 2.41142 10.893 1.95729 9.79667C1.50317 8.70031 1.38435 7.49391 1.61586 6.33003C1.84737 5.16614 2.41881 4.09704 3.25793 3.25793C4.09704 2.41881 5.16614 1.84737 6.33003 1.61586C7.49391 1.38435 8.70031 1.50317 9.79667 1.95729C10.893 2.41142 11.8301 3.18045 12.4894 4.16715C13.1487 5.15384 13.5006 6.31388 13.5006 7.50057C13.4988 9.09132 12.8661 10.6164 11.7412 11.7412C10.6164 12.8661 9.09132 13.4988 7.50057 13.5006Z"
            fill="#AEAFB8"
          />
        </svg>
      </div>
      <input
        className="form-control input_search search"
        type="text"
        placeholder={defaultPlaceholder}
        value={searchTerm}
        onChange={handleInput}
        onBlur={handleBlur}
        onKeyDown={handleKeydown}
      />
    </div>
  );
};

export default SearchBox;
